module.exports = __webpack_public_path__ + "static/media/midday-slot-icon.d707152a.svg";